import React , { useState }  from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import api from './../../../api';
import { toastrAdd } from './../../../actions';

function SendEmailTestModal(props) {
    const { disabled, email, callback } = props;
    const { t } = useTranslation();
    const [receiver, setReceiver] = useState(null);
    const dispatch = useDispatch();
    const _onChange = ({target}) => {
        setReceiver(target.value);
    }

    const _onSend = (event) => {
        event.preventDefault();
        sendTestEmail(email, receiver);
    }

    /**
     * Send test email to a specific email address
     *
     * @param {object} data
     * @param {string} receiver
     */
    const sendTestEmail = (data, receiver) => {
        api.email.saveEmail(data).then(responseA => {
            api.email.sendTestEmail(responseA.data.data.partnerEmail.partnerEmailId, { email: receiver }).then(responseB => {
                dispatch(toastrAdd({code: 0, details: t('emails.test_send_success_details'), title: t('emails.test_send_success_title'), type: 'success'}));
                callback && callback();
                props.onHide();
            })
            .catch(error => {
                dispatch(toastrAdd({code: 0, details: `${t('general.details')}: ${error.errors[0].details}`, title: t('emails.send_fail_title'), type: 'error'}));
            })
        })
        .catch(error => {
            dispatch(toastrAdd({code: 0, details: `${t('general.details')}: ${error.errors[0].details}`, title: t('errors.general_form_error_title'), type: 'error'}));
        }) 
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form onSubmit={_onSend}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('emails.send_email_test_header')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    
                        <Form.Label>{t('general.emailAddress')}</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder={t('general.emailAddress')}
                            name="email"
                            onChange={_onChange}
                            autoFocus
                            disabled={disabled}
                            required
                        />  
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" variant="success">
                        {t('emails.send_email_test')}
                    </Button>
                    <Button type="button" variant="default" onClick={() => props.onHide()}>
                        {t('general.close')}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default SendEmailTestModal;